import api from "@/network";

export default {
    async getTags(search: string) {
        return await api.get(
            `dictionary/tags`,
            { params: { search } }
        );
    },
}